import { RootState } from 'store/reducers'

export const selectManagementActiveTab = (store: RootState) =>
  store.management.activeTab
